import { BackgroundImage, Box, Center } from '@mantine/core';

import classes from './index.module.css';
import { ReactNode } from 'react';

interface IHeroBackground {
  background?: boolean;
  image?: any;
  children?: ReactNode;
}

const HeroBackground = ({
  image,
  background,
  children
}: IHeroBackground) => {
  let content = (
    <BackgroundImage className={classes.image} src={image}>
      <Center className={classes.content}>{children}</Center>
    </BackgroundImage>
  )

  if (background) {
    content = (
      <Box className={classes.background}>
        <Center className={classes.content}>{children}</Center>
      </Box>
    )
  }

  return content;
}

export default HeroBackground;